export default "__VITE_ASSET__WVo0QESk__"